import { Dialog } from '@wwe-portal/ui/components/dialog';
import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { Textfit } from '@wwe-portal/ui/components/text-fit';

import { SubscriptionCarouselSkeleton } from '@wwe-portal/ui/features/subscription/card/subscription-carousel-skeleton';
import {
  ChangePlanDialog,
  SubscriptionCarousel,
} from '@wwe-portal/ui/features/subscription';
import { LoginDialog } from '@wwe-portal/ui/features/auth/login-dialog';
import { useSubscriptionContext } from './provider';

import { SubscriptionLayout } from '@wwe-portal/ui/features/subscription/layout';
import { FaqSection } from './faq-section';
import Image from 'next/image';

export function SubscriptionConsumer() {
  const {
    subscription,
    mutation,
    currentPlan,
    loginState,
    changeDialogState,
    isLoading,
  } = useSubscriptionContext();

  return (
    <>
      <SubscriptionLayout
        title={
          <Textfit
            className="text-text300 px-4 text-center font-semibold"
            max={16}
            mode="single"
          >
            {subscription.data?.subscriptionTitle ?? (
              <Skeleton className="inline-block h-4 w-2/3" />
            )}
          </Textfit>
        }
        subtitle={
          <Textfit
            className="text-text300 mt-2 h-12 px-8 text-center text-sm font-light"
            max={14}
            mode="multi"
          >
            {subscription.data?.subscriptionDescription ?? (
              <>
                <Skeleton className="inline-block h-4 w-full" />
                <Skeleton className="inline-block h-4 w-full" />
              </>
            )}
          </Textfit>
        }
        subscriptionCards={
          !isLoading && subscription.data?.plans?.length ? (
            <SubscriptionCarousel
              currentPlan={currentPlan}
              items={subscription.data.plans}
              mutatingPlanId={mutation.subscribingPlan?.id}
              onHideMore={subscription.hideMoreInfo}
              onShowMore={subscription.showMoreInfo}
              onSubscribe={mutation.subsribe}
              showingMorePlanIds={subscription.showingMorePlanIds}
            />
          ) : (
            <SubscriptionCarouselSkeleton />
          )
        }
        logo={
          <Image
            alt="champion logo"
            height={45}
            src="/assets/images/subscription/champions-logo.webp"
            width={55}
          />
        }
        faq={<FaqSection />}
      />

      {loginState ? <LoginDialog {...loginState} /> : null}
      {changeDialogState ? (
        <Dialog
          onOpenChange={(value) => {
            if (!value) {
              changeDialogState.onClose();
            }
          }}
          open
        >
          <ChangePlanDialog
            buttonContent={changeDialogState.buttonContent}
            description={changeDialogState.description}
            isUpgrading={mutation.isLoading}
            onChange={changeDialogState.onChange}
            onClose={changeDialogState.onClose}
          />
        </Dialog>
      ) : null}
    </>
  );
}
